import { StorageType } from '@constants/common';

export const getStorage = (type: StorageType) => {
  switch (type) {
    case StorageType.SESSION:
      return window.sessionStorage;
    default:
      return window.localStorage;
  }
};

export const isStorageAvailable = (storageType: StorageType) => {
  try {
    const storage = window[storageType];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (error) {
    return false;
  }
};
